import React from "react"

import style from "./index.module.sass"

// ----------------------------------------------------------------------------

const COLORS = {BLUE: "blue", RED: "red", YELLOW: "yellow", GREY: "grey"}

function BubbleCard(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { children, color = COLORS.BLUE } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  let mode = style.blue
  switch (color) {
    case COLORS.RED:
      mode = style.red
      break
    case COLORS.YELLOW:
      mode = style.yellow
      break
    case COLORS.GREY:
      mode = style.grey
      break
  }

  // -------------------------------------

  return (
    <div className={`${style.bubbleCard} ${mode}`}>
      <div className={`${style.bubble} ${style.bubbleTopLeft}`}></div>
      <div className={`${style.bubble} ${style.bubbleBottomRight}`}></div>
      {children}
    </div>
  )
}

// ----------------------------------------------------------------------------

export default BubbleCard
